// Services Data
export const services = [
  {
    id: 1,
    image: 'https://images.unsplash.com/photo-1541888946425-d81bb19240f5?w=900&q=80&auto=format&fit=crop',
    title: 'Civil Construction',
    description: 'Expert civil contracting services for Kerala government works and private sector developments, delivering robust infrastructure solutions.',
    features: ['Government Infrastructure', 'Private Developments', 'Foundation Work'],
  },
  {
    id: 2,
    image: 'https://images.unsplash.com/photo-1600585154340-be6161a56a0c?w=900&q=80&auto=format&fit=crop',
    title: 'Turnkey Projects',
    description: 'Complete end-to-end construction solutions from design to handover, ensuring seamless project execution.',
    features: ['Design-Build', 'Complete Management', 'Timely Delivery'],
  },
  {
    id: 3,
    image: 'https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=900&q=80&auto=format&fit=crop',
    title: 'Project Management',
    description: 'Professional construction management services ensuring optimal resource utilization and quality standards.',
    features: ['Planning & Scheduling', 'Cost Control', 'Quality Assurance'],
  },
  {
    id: 4,
    image: 'https://images.unsplash.com/photo-1497366216548-37526070297c?w=900&q=80&auto=format&fit=crop',
    title: 'Construction Consulting',
    description: 'Strategic consulting services for construction planning, feasibility studies, and project optimization.',
    features: ['Feasibility Analysis', 'Cost Estimation', 'Technical Advisory'],
  },
  {
    id: 5,
    image: 'https://images.unsplash.com/photo-1487958449943-2429e8be8625?w=900&q=80&auto=format&fit=crop',
    title: 'Planning & Design',
    description: 'Comprehensive planning and design services integrating engineering excellence with practical construction solutions.',
    features: ['Structural Design', 'Site Planning', 'MEP Engineering'],
  },
  {
    id: 6,
    image: 'https://images.unsplash.com/photo-1503387762-592deb58ef4e?w=900&q=80&auto=format&fit=crop',
    title: 'Research & Development',
    description: 'Innovative R&D initiatives focused on sustainable construction methods and modern building technologies.',
    features: ['Sustainable Materials', 'Modern Techniques', 'Innovation Labs'],
  },
];

// Services Section Content
export const servicesContent = {
  label: 'What We Do',
  title: 'Comprehensive Construction Services',
  titleHighlight: 'Construction Services',
  subtitle: 'Specializing in Kerala government infrastructure projects and private sector construction. Over 10 years of proven expertise delivering quality solutions across the state.',
};
